export default (store, initialState) => {
  /* eslint-disable */
  store.mutations['resetState'] = state => {
    Object.assign(state, initialState)
  }
  store.actions['resetState'] = ({ commit }) => {
    commit('resetState')
  }
  /* eslint-enable */
  return store
}
